import { render } from "./GzList.vue?vue&type=template&id=f92b0438&scoped=true"
import script from "./GzList.vue?vue&type=script&lang=js"
export * from "./GzList.vue?vue&type=script&lang=js"

import "./GzList.vue?vue&type=style&index=0&id=f92b0438&scoped=true&lang=less"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f92b0438"]])

export default __exports__